import Backbone from '@polleverywhere/backbone'
import subscribe from '@polleverywhere/firehose_client'
import { Monitor } from './monitor'
import env from '@polleverywhere/core/lib/env'

export class RemoteControl {
  constructor ({ user }) {
    this.handleMessage = this.handleMessage.bind(this)
    this.subscribe = this.subscribe.bind(this)
    this.start = this.start.bind(this)
    this.user = user
    this.monitor = new Monitor({ user })
    this.presentation = window.presentation
  }

  async handleMessage (msg) {
    if (!msg) {
      console.log('msg does not exist.')
      return
    }

    console.log(`Action msg.action=${msg.action}`)
    switch (msg.action) {
      case 'connect':
        this.monitor.start()
        break
      case 'next':
        try {
          if (await this.presentation.isPresenting()) {
            return this.presentation.nextSlide()
          }
        } catch (error) { }
        break
      case 'previous':
        try {
          if (await this.presentation.isPresenting()) {
            return this.presentation.prevSlide()
          }
        } catch (error) { }
        break
      default:
        console.log(`Defaulted - msg.action=${msg.action}`)
    }
  }

  subscribe (firehoseToken) {
    if (!firehoseToken) {
      return
    }

    this._subscriptionChannel = subscribe(`/presentations/${this.user.get('id')}/secure`, {
      host: env.get('firehose_url').toString(),
      ssl: env.get('firehose_ssl'),
      params: {
        firehose_token: firehoseToken
      }
    })

    this._subscriptionChannel.once('connected', () => {
      console.log('Connected!')
    })

    this._subscriptionChannel.on('message', this.handleMessage)

    this._subscriptionChannel.on('down', () => {
      console.log('Connection: DOWN')
    })

    this._subscriptionChannel.on('up', () => {
      console.log('Connection: UP')
    })

    this._subscriptionChannel.on('error', (error) => {
      console.log(`Error: ${JSON.stringify(error)}`)
    })

    this._subscriptionChannel.on('failed', (error) => {
      console.log(`Connection: FAILED: ${JSON.stringify(error)}`)
    })
  }

  start () {
    return Backbone
      .ajax({
        dataType: 'json',
        url: '/api/firehose_tokens/remote_control',
        type: 'GET'
      })
      .then((data) => {
        if (!data) {
          throw new Error('Data is invalid', data)
        }

        if (!data.firehose_token) {
          throw new Error('firehose_token is invalid', data)
        }

        return this.subscribe(data.firehose_token)
      })
  }
}
